




























import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { NewWebsiteDTO } from "../../Generated/ParticaAPI";

@Component(
	{
		name: "NewWebsiteForm",
		components: { ButtonList }
	})
export default class NewWebsiteForm extends ParticaBaseForm<NewWebsiteDTO> {

	private urlconfig =
		{
			props: { name: "url", placeholder: "Enter the domain name", label: "Domain", } as FormFieldProps,
			rules: { required: true, url: true, } as FormFieldRules
		} as IFormField;

	private titleNameconfig =
		{
			props: { name: "titleName", placeholder: "Enter the new title name", label: "Title name", } as FormFieldProps,
			rules: { required: true, max: 200, min: 5, } as FormFieldRules
		} as IFormField;

	private slugconfig =
		{
			props: { name: "slug", placeholder: "Enter title slug", label: "Title Slug", } as FormFieldProps,
			rules: { required: true, max: 64, min: 5, } as FormFieldRules
		} as IFormField;

}
